import { NgModule } from '@angular/core';
import { LocationMultiSelectorComponent } from './location-multi-selector.component';
import { LocationMultiSelectorTreeViewComponent } from './location-multi-selector-tree-view/location-multi-selector-tree-view.component';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    LocationMultiSelectorTreeViewComponent,
    LocationMultiSelectorComponent 
  ],
  imports: [
    CommonModule,
    FormsModule,
    ButtonsModule,
    TreeViewModule
  ],
  exports:[
    LocationMultiSelectorComponent
  ],
  entryComponents: [LocationMultiSelectorComponent]
})
export class LocationMultiSelectorModule { }
